import { useEffect, useState } from "react";
import { Alternador, Botao, Campo, Cortina, Escolha, LinhaDeAjuste, Secao, Seletor } from "../componentes/comuns.jsx";
import {
  BITRATES,
  IDIOMAS,
  INTERVALOS,
  JANELAS,
  MODOS,
  comModo,
  listarMicrofones,
  modoDe,
  salvarConfig,
} from "../funcionalidades/reunioes/config.ts";

/**
 * Ajustes da gravação — preferências da MÁQUINA de quem grava.
 *
 * Saiu da vista Reuniões junto com o gravador: quem abre isto está a um clique de
 * gravar, e o lugar de gravar agora é a aba Reunião do atendimento.
 */
export default function AjustesDaGravacao({ config, aoMudar, aoFechar }) {
  const [microfones, setMicrofones] = useState([]);
  useEffect(() => {
    void listarMicrofones().then(setMicrofones);
  }, []);

  const trocar = (mudanca) => aoMudar(salvarConfig({ ...config, ...mudanca }));

  return (
    <Cortina
      aoFechar={aoFechar}
      largura="560px"
      titulo="Ajustes da gravação"
      acima="Ficam neste navegador: são preferências da máquina de quem grava. Microfone escolhido aqui não vale no outro computador — e é assim que tem de ser."
      rodape={<Botao rotulo="Pronto" destaque aoTocar={aoFechar} />}
    >
      <Escolha
        rotulo="Modo da gravação"
        valor={modoDe(config)}
        aoEscolher={(modo) => trocar(comModo(config, modo))}
        opcoes={MODOS.map((m) => ({ id: m.id, rotulo: m.rotulo, detalhe: m.ajuda }))}
      />

      <Secao espaco="16px 0 4px">QUALIDADE E IDIOMA</Secao>
      <LinhaDeAjuste rotulo="Microfone" ajuda="O nome só aparece depois de o navegador ter permissão" primeira>
        <Seletor
          rotulo="Microfone"
          largura="220px"
          valor={config.microfoneId}
          opcoes={[{ id: "", rotulo: "Padrão do sistema" }, ...microfones.map((m) => ({ id: m.id, rotulo: m.rotulo }))]}
          aoEscolher={(microfoneId) => trocar({ microfoneId })}
        />
      </LinhaDeAjuste>
      <LinhaDeAjuste rotulo="Qualidade do áudio" ajuda="Quanto cabe num arquivo, com o teto do provedor">
        <Seletor
          rotulo="Qualidade"
          largura="220px"
          valor={String(config.bitrate)}
          opcoes={BITRATES}
          aoEscolher={(b) => trocar({ bitrate: Number(b) })}
        />
      </LinhaDeAjuste>
      <LinhaDeAjuste rotulo="Idioma do áudio" ajuda="`Detectar` erra mais em áudio curto">
        <Seletor
          rotulo="Idioma"
          largura="220px"
          valor={config.idioma}
          opcoes={IDIOMAS}
          aoEscolher={(idioma) => trocar({ idioma })}
        />
      </LinhaDeAjuste>
      <LinhaDeAjuste
        rotulo="Como chamar o outro lado"
        ajuda="Usado quando a gravação não tem caso: com caso aberto, quem manda é o nome do cliente na ficha"
      >
        <div className="w-[220px]">
          <Campo rotulo="Rótulo do outro lado" valor={config.rotuloOutroLado} aoMudar={(v) => trocar({ rotuloOutroLado: v })} />
        </div>
      </LinhaDeAjuste>

      <Secao espaco="16px 0 4px">DURANTE A REUNIÃO</Secao>
      <LinhaDeAjuste
        rotulo="Ler o nome de quem fala na tela"
        ajuda="Amostra quadros da aba e devolve “Marina Alves” no lugar de “Cliente”. Custa pedidos à IA."
        primeira
      >
        <Alternador ligado={config.lerNomes} aoTocar={() => trocar({ lerNomes: !config.lerNomes })} rotulo="Ler nomes" />
      </LinhaDeAjuste>
      {config.lerNomes ? (
        <LinhaDeAjuste rotulo="Intervalo entre quadros" ajuda="Mais fino pega troca rápida de falante; mais largo custa menos">
          <Seletor
            rotulo="Intervalo"
            largura="260px"
            valor={String(config.intervaloQuadro)}
            opcoes={INTERVALOS}
            aoEscolher={(v) => trocar({ intervaloQuadro: Number(v) })}
          />
        </LinhaDeAjuste>
      ) : null}
      <LinhaDeAjuste
        rotulo="Prévia ao vivo"
        ajuda="Transcreve janelas curtas durante a reunião — serve para não descobrir no fim que o áudio estava mudo"
      >
        <Alternador ligado={config.previaAoVivo} aoTocar={() => trocar({ previaAoVivo: !config.previaAoVivo })} rotulo="Prévia" />
      </LinhaDeAjuste>
      {config.previaAoVivo ? (
        <LinhaDeAjuste rotulo="Janela da prévia" ajuda="Janela maior corta menos frase no meio">
          <Seletor
            rotulo="Janela"
            largura="260px"
            valor={String(config.janelaPrevia)}
            opcoes={JANELAS}
            aoEscolher={(v) => trocar({ janelaPrevia: Number(v) })}
          />
        </LinhaDeAjuste>
      ) : null}

      <Secao espaco="16px 0 4px">DEPOIS</Secao>
      <LinhaDeAjuste
        rotulo="Guardar o áudio"
        ajuda="Ligado, dá para ouvir de novo. Desligado, o áudio some depois de virar texto — conversa com cliente é passivo."
        primeira
      >
        <Alternador
          ligado={config.guardarAudio}
          aoTocar={() => trocar({ guardarAudio: !config.guardarAudio })}
          rotulo="Guardar áudio"
        />
      </LinhaDeAjuste>
      {/* Só faz sentido quando existe aba compartilhada — sem ela não há imagem a
          guardar, e um interruptor que não muda nada é a tela mentindo. */}
      <LinhaDeAjuste
        rotulo="Guardar o vídeo da aba"
        ajuda={
          config.gravarAba
            ? "A chamada em imagem, com a mistura das vozes — serve quando VER importa (o documento que o cliente mostrou na tela). Pesa cerca de 9 MB por minuto e é o passivo mais delicado da reunião."
            : "Disponível no modo “Chamada online” ou “Só o áudio da aba”: sem aba compartilhada não há imagem para guardar."
        }
      >
        <Alternador
          ligado={config.gravarAba && config.guardarVideo}
          aoTocar={() => config.gravarAba && trocar({ guardarVideo: !config.guardarVideo })}
          rotulo="Guardar vídeo"
          titulo={config.gravarAba ? undefined : "Ligue um modo com áudio da aba primeiro"}
        />
      </LinhaDeAjuste>
      <LinhaDeAjuste rotulo="Resumir sozinho" ajuda="Gera o resumo assim que a transcrição chega">
        <Alternador
          ligado={config.resumirAoTerminar}
          aoTocar={() => trocar({ resumirAoTerminar: !config.resumirAoTerminar })}
          rotulo="Resumir sozinho"
        />
      </LinhaDeAjuste>
    </Cortina>
  );
}
